if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.form.addEventListener('change', this.onKampfinityOptionChange.bind(this));

      }

      connectedCallback() {
        this.updateKampfinityConditionalFields();
        if (this.kampfinityVariantChangeUnsubscriber) return;

        this.kampfinityVariantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data.sectionId) !== String(this.dataset.sectionId)) return;
          requestAnimationFrame(() => this.updateKampfinityDisplayedPrice());
        });
        this.updateKampfinityDisplayedPrice();
      }

      disconnectedCallback() {
        this.kampfinityVariantChangeUnsubscriber?.();
        this.kampfinityVariantChangeUnsubscriber = undefined;
      }

      onKampfinityOptionChange(event) {
        if (!event.target.matches('input, select')) return;
        this.updateKampfinityConditionalFields();
        this.updateKampfinityDisplayedPrice();
      }

      updateKampfinityConditionalFields() {
        const garageHeightFields = this.form.querySelectorAll('[data-kampfinity-garage-height-field]');
        if (!garageHeightFields.length) return;

        const tensionSetSelected = Boolean(
          this.form.querySelector('input[data-kampfinity-requires-garage-height="true"]:checked')
        );

        garageHeightFields.forEach((garageHeightField) => {
          const garageHeightSelect = garageHeightField.querySelector('select');
          if (!garageHeightSelect) return;

          garageHeightField.hidden = !tensionSetSelected;
          garageHeightSelect.disabled = !tensionSetSelected;
          garageHeightSelect.required = tensionSetSelected;
          garageHeightSelect.toggleAttribute('aria-required', tensionSetSelected);
          garageHeightSelect.toggleAttribute('data-required-product-property', tensionSetSelected);

          if (!tensionSetSelected) garageHeightSelect.value = '';
        });
      }

      updateKampfinityDisplayedPrice() {
        const productInfo = this.closest('product-info');
        const price = productInfo?.querySelector(
          `[id="price-${this.dataset.sectionId}"] .price[data-kf-base-cents]`
        );
        if (!price) return;

        const hasSurcharge = Boolean(this.form.querySelector('input[data-kampfinity-surcharge="true"]:checked'));
        const operation = this.form.querySelector('[data-kf-addon="operation"]:checked');
        const cents = Number(price.dataset.kfBaseCents) + (hasSurcharge ? Number(price.dataset.kfFrameCents) : 0) + (operation ? Number(operation.dataset.kfAddonPrice || 2500) : 0);
        const displayedPrice = new Intl.NumberFormat(document.documentElement.lang || 'nl', {style:'currency', currency:price.dataset.kfCurrency || 'EUR'}).format(cents / 100);
        const direction = this.form.querySelector('[data-kf-operation-direction]');
        if (direction) {
          const variantFrame = [...productInfo.querySelectorAll('variant-selects input:checked')].some(input => /montagekader|mounting frame|montagerahmen|cadre|bastidor|marco|telaio|rám|ramme|estrutura|ram/i.test(input.value) && !/zonder|without|ohne|sans|sin |senza|bez |uden|uten|sem |utan/i.test(input.value));
          const operationIncluded = Boolean(this.form.querySelector('[data-kf-operation-included]'));
          direction.disabled = !(operation || operationIncluded);
          const directionLabels = {"nl": ["Standaard gemonteerd (met montagekader)", "Omgekeerd gemonteerd (zonder montagekader)"], "en": ["Standard mounting (with mounting frame)", "Reverse mounting (without mounting frame)"], "de": ["Standardmontage (mit Montagerahmen)", "Umgekehrte Montage (ohne Montagerahmen)"], "fr": ["Montage standard (avec cadre)", "Montage inversé (sans cadre)"], "es": ["Montaje estándar (con bastidor)", "Montaje invertido (sin bastidor)"], "it": ["Montaggio standard (con telaio)", "Montaggio invertito (senza telaio)"], "cs": ["Standardní montáž (s rámem)", "Obrácená montáž (bez rámu)"], "da": ["Standardmontering (med ramme)", "Omvendt montering (uden ramme)"], "nb": ["Standardmontering (med ramme)", "Omvendt montering (uten ramme)"], "no": ["Standardmontering (med ramme)", "Omvendt montering (uten ramme)"], "pt": ["Montagem padrão (com estrutura)", "Montagem invertida (sem estrutura)"], "sv": ["Standardmontering (med ram)", "Omvänd montering (utan ram)"]};
          const language = document.documentElement.lang.split("-")[0];
          direction.value = (operation || operationIncluded) ? (directionLabels[language] || directionLabels.en)[hasSurcharge || variantFrame ? 0 : 1] : "";
        }
        const currentPrice = price.classList.contains('price--on-sale')
          ? price.querySelector('.price__sale .price-item--sale.price-item--last')
          : price.querySelector('.price__regular > .price-item--regular');

        if (currentPrice && displayedPrice) currentPrice.textContent = displayedPrice;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const missingRequiredProperty = Array.from(
          this.form.querySelectorAll('[data-required-product-property]')
        ).find((input) => {
          if (input.type === 'radio') {
            return !Array.from(this.form.querySelectorAll('input[type="radio"]')).some(
              (radio) => radio.name === input.name && radio.checked
            );
          }

          return !input.value.trim();
        });

        if (missingRequiredProperty) {
          this.handleErrorMessage(missingRequiredProperty.dataset.errorMessage || ({"nl": "Vul de verplichte velden in.", "en": "Complete the required fields.", "de": "Bitte füllen Sie die Pflichtfelder aus.", "fr": "Veuillez remplir les champs obligatoires.", "es": "Completa los campos obligatorios.", "it": "Compila i campi obbligatori.", "cs": "Vyplňte povinná pole.", "da": "Udfyld de obligatoriske felter.", "nb": "Fyll ut de obligatoriske feltene.", "no": "Fyll ut de obligatoriske feltene.", "pt": "Preencha os campos obrigatórios.", "sv": "Fyll i de obligatoriska fälten."})[document.documentElement.lang.split("-")[0]] || "Complete the required fields.");
          missingRequiredProperty.focus();
          return;
        }

        const operation = this.form.querySelector('[data-kf-addon="operation"]:checked');
        if (operation && (!Number(operation.dataset.kfAddonId) || operation.dataset.kfAddonAvailable !== 'true')) {
          this.handleErrorMessage(({"nl": "Eénhandbediening is momenteel niet beschikbaar. Neem contact op met Kampfinity.", "en": "One-handed operation is currently unavailable. Please contact Kampfinity.", "de": "Einhandbedienung ist derzeit nicht bestellbar. Bitte kontaktieren Sie Kampfinity.", "fr": "La commande à une main est actuellement indisponible. Contactez Kampfinity.", "es": "El accionamiento con una mano no está disponible actualmente. Contacta con Kampfinity.", "it": "Il comando a una mano non è attualmente disponibile. Contatta Kampfinity.", "cs": "Ovládání jednou rukou momentálně není k dispozici. Kontaktujte Kampfinity.", "da": "Enhåndsbetjening er i øjeblikket ikke tilgængelig. Kontakt Kampfinity.", "nb": "Enhåndsbetjening er for øyeblikket ikke tilgjengelig. Kontakt Kampfinity.", "no": "Enhåndsbetjening er for øyeblikket ikke tilgjengelig. Kontakt Kampfinity.", "pt": "O acionamento com uma mão não está disponível de momento. Contacte a Kampfinity.", "sv": "Enhandsmanövrering är för närvarande inte tillgänglig. Kontakta Kampfinity."})[document.documentElement.lang.split("-")[0]] || "One-handed operation is currently unavailable. Please contact Kampfinity.");
          return;
        }
        this.updateKampfinityDisplayedPrice();
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        const formData = new FormData(this.form);
        const productVariantId = formData.get('id');
        const selectedSurcharge = this.form.querySelector('input[data-kampfinity-surcharge="true"]:checked');
        const surchargeVariantId = Number(this.dataset.frameSurchargeVariantId);
        const sectionIds = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [];

        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }

        if ((selectedSurcharge && surchargeVariantId) || operation) {
          const quantity = Number(formData.get('quantity')) || 1;
          const groupId = `frame-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
          const properties = {};

          for (const [name, value] of formData.entries()) {
            if (!name.startsWith('properties[') || !name.endsWith(']') || value === '') continue;
            properties[name.slice(11, -1)] = value;
          }

          properties._kampfinity_frame_group = groupId;

          const mainItem = {
            id: Number(productVariantId),
            quantity,
            properties,
          };
          const sellingPlan = formData.get('selling_plan');
          if (sellingPlan) mainItem.selling_plan = sellingPlan;

          const addonIds = [];
          if (selectedSurcharge && surchargeVariantId) addonIds.push(surchargeVariantId);
          if (operation) addonIds.push(Number(operation.dataset.kfAddonId));
          config.body = JSON.stringify({
            items: [
              mainItem,
              ...addonIds.map(id => ({
                id,
                quantity,
                properties: {
                  _kampfinity_frame_group: groupId,
                  _kampfinity_frame_surcharge: 'true',
                  [this.dataset.frameProductLabel || 'Voor product']: this.dataset.productTitle || 'Module',
                },
              })),
            ],
            sections: sectionIds,
            sections_url: window.location.pathname,
          });
        } else {
          delete config.headers['Content-Type'];
          if (this.cart) {
            formData.append('sections', sectionIds);
            formData.append('sections_url', window.location.pathname);
          }
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const mainAddedItem = Array.isArray(response.items)
              ? response.items.find(
                  (item) =>
                    String(item.id) === String(productVariantId) &&
                    item.properties?._kampfinity_frame_surcharge !== 'true'
                ) || response.items[0]
              : response;
            const renderState = Array.isArray(response.items)
              ? { ...mainAddedItem, sections: response.sections }
              : response;

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(renderState);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(renderState);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
